import { render, staticRenderFns } from "./FooterColumns.vue?vue&type=template&id=7d1a38a6&"
import script from "./FooterColumns.vue?vue&type=script&lang=js&"
export * from "./FooterColumns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports